<template>
    <div class="mdt-offers-wrap">
        <div class="section-title">
            <h2>{{ title }}</h2>
        </div>
        <div class="categories-caroursel-wrap">
            <filter-carousel :offers="articles" @filter="filterList"></filter-carousel>
        </div>
        <sorter :items="articles" :screen-name="title" @sortingcommand="sorting"></sorter>
        <div v-if="sectionType === `hotels`" class="articles-list hotels-list" style="grid-template-columns: auto auto auto">
            <market-hotel-item v-for="(i, article) in articles" :key="i" :item-data="article"></market-hotel-item>
        </div>
        <div v-else :class="`articles-list ${sectionType}-list`">
            <market-item v-for="(i, article) in articles" :key="i" :item-data="article"></market-item>
        </div>
    </div>
</template>

<script>

import marketItem from './market-item.vue'
import marketHotelItem from './market-hotel-item.vue'
import filterCarousel from './market-filter.vue'
import sorter from './sorter.vue';

export default {
    name: 'market-section',
    props: {
        title: String,
        sectionType: String
    },
    components: {
        marketItem,
        marketHotelItem,
        filterCarousel,
        sorter
    },
    created() {
        this.service_id = this.$route.params.id;
        this.getArticles();
    },
    methods: {
        filterList: function (filteringBy) {
            this.articles = this.articlesClone;
            this.articles = this.articles.filter(article => article.category == filteringBy);
        },
        sorting: function (sortBy) {
            if (sortBy == '1') this.articles.sort((a, b) => (a.price - b.price));
            else this.articles.sort((a, b) => (b.price - a.price));
        },
        getArticles(){
            this.$http.get(apiUrl + `/service-types/${this.service_id}/articles`).then(response => {
                this.articles = response.data;
                this.articlesClone = response.data;
            });
        }
    },
    data: function () {
        return {
            something: 'null',
            articles: {},
            articlesClone: {},
        }
    }
}
</script>

<style scoped>
    .mdt-offers-wrap {
        background-color: #FAFAFA;
        width: 100%;
    }

    .section-title h2 {
        font-weight: 800;
        text-align: center;
    }
    
    .categories-caroursel-wrap {
        padding: 5px 0;
    }

    .articles-list {
        display: flex;
        flex-flow: row wrap;
        margin-top: 10px;
        margin-bottom: 50px;
        justify-content: center;
    }

    .articles-list > div {
        cursor: pointer;
        flex-basis: 0;
    }

    @media (max-width: 1250px) {
        .articles-list {
           justify-content: center;
        }
    }

</style>


// WEBPACK FOOTER //
// market-section.vue?91fb0664